// extracted by mini-css-extract-plugin
export default {"hour-log-page":"HourLogPage_hour-log-page__BSvJP","hour-log-title":"HourLogPage_hour-log-title__SvM+y"};